module.exports = __webpack_public_path__ + "img/step2.375516e0.png";